import { defineStore } from 'pinia'

import Hot17Repository from '@/app/repositories/hot-17-repository'
import { Hot17Entry } from '@/common/models/data/dashboard/hot-17/hot-17-entry'
import { Hot17IndexResponse } from '@/common/models/responses/hot17-index-response'

const useHot17Store = defineStore('hot17', {
    state: () => ({
        data: new Hot17IndexResponse()
    }),
    actions: {
        async load (): Promise<void> {
            this.data = await Hot17Repository.all()
        },
        async reset (): Promise<boolean> {
            if (!await Hot17Repository.reset()) {
                return false
            }

            await this.load()

            return true
        },
        async vote (votes: Array<number>): Promise<boolean> {
            if (!await Hot17Repository.vote(votes)) {
                return false
            }

            await this.load()

            return true
        }
    },
    getters: {
        alreadyVoted (): boolean {
            return this.userVotes.length > 0
        },
        entries: (state): Array<Hot17Entry> => {
            return [...state.data.entries].sort((lhs, rhs): number => {
                return lhs.song.localeCompare(rhs.song)
            })
        },
        isEnabled: (state): boolean => {
            return state.data.enabled
        },
        sortedEntries: (state): Array<Hot17Entry> => {
            // slice(0, 17) here, because we want to show only 17 entries after the voting phase is done,
            // and we only show sorted results when voting phase is done
            return [...state.data.entries].sort((lhs, rhs): number => {
                return rhs.votes_count - lhs.votes_count
            }).slice(0, 17)
        },
        userVotes: (state): Array<number> => {
            return state.data.votes.map(item => item.entry_id)
        }
    }
})

export {
    useHot17Store
}
